import React, { useState, useContext } from "react";
import { Button, IconButton, Card, Stack, Typography } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DescriptionIcon from "@mui/icons-material/Description";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LocationIcon from "@mui/icons-material/LocationOnOutlined";

import config from "../../../hoa-config";
import "../../hoa-styles.scss";
import "../../municipalities/hoa-municipality-styles.scss";

import { GlobalContext } from "../../../context/hoa-global-context";
import { getDateOnly } from "../../../utility/get-formated-date";
import useFieldDisabled from "../../../hooks/useFieldDisabled";
import AddAmenityModal from "./amenities-component/Amenities";
import AddAmenityEvent from "./amenities-component/AmenityEvent";
import AmenityEntityBlankComponent from "./amenity-entity-blank-component";
import DeleteAttachmentComp from "./amenities-component/AmenitiesDeleteAttachment";
import AddAccessInformationModal from "./amenities-component/AmenityAccessInformation";
import { getNegativeValueInAccountingForm } from "../../../utility/format-display-output";

const filteredAmenityOptions = Object.keys(config.amenityIcons).filter((item) => item !== "Beache Access");
interface HoaAemnitiesFormProps {
	hoa: any;
	previousHoa: any;
	setCurrentHoa: any;
	updateHoaData: any;
	updateSelectedValues: any;
	newAvailableAmenities: any;
	setNewAvailableAmenities: any;
	amenityEvents: any;
	setAmenityEvents: any;
	accessInformation: any;
	setAccessInformation: any;
	height: number;
	selectedMunicipality: any;
	view: string;
	selectedValues: any;
	checkNewAmenitiesWarning: any;
	setState: any;
	state: any;
}

export default function HoaNewAemnitiesForm(props: HoaAemnitiesFormProps) {
	const { amenitiesDocImage, updateAmenitiesDocImage } = useContext<any>(GlobalContext);
	const { isHoaFieldDisabled } = useFieldDisabled();
	const {
		hoa,
		previousHoa,
		setCurrentHoa,
		updateHoaData,
		updateSelectedValues,
		newAvailableAmenities,
		setNewAvailableAmenities,
		amenityEvents,
		setAmenityEvents,
		accessInformation,
		setAccessInformation,
		view,
		selectedValues,
		checkNewAmenitiesWarning,
		state,
		setState,
	} = props;
	const [amenityOptions, setAmenityOptions] = useState(filteredAmenityOptions);
	const [amenityTags, setAmenityTags] = useState(filteredAmenityOptions);
	const [selectedLocationIndex, setSelectedLocationIndex] = useState(null);
	const [open, toggleOpen] = useState(false);
	const [toBeDelete, setToBeDelete] = useState({});
	const [selectedDocument, setSelectedDocument] = useState({});
	const [documentName, setDocumentName] = useState("");
	const [eventOpen, setEventOpen] = useState(false);
	const [amenitiyOpen, setAmenityOpen] = useState(false);
	const [accessInformationOpen, setAccessInformationOpen] = useState(false);
	const [event, setEvent] = useState<any>({});
	const [availableAmenity, setAvailableAmenity] = useState<any>({});
	const [tempAccessInformation, setTempAccessInformation] = useState<any>({});
	const [toBeEditedEvent, setToBeEditedEvent] = useState<any>({});
	const [toBeEditedAvailableAmenity, setToBeEditedAvailableAmenity] = useState<any>({});
	const [toBeEditedAccessInformation, setToBeEditedAccessInformation] = useState<any>({});
	const [toBeDeleteEvent, setToBeDeleteEvent] = useState<any>({});
	const [toBeDeleteAccessInformation, setToBeDeleteAccessInformation] = useState<any>({});
	const [toBeDeleteAmenity, setToBeDeleteAmenity] = useState<any>({});

	const handleEventClose = () => {
		setEventOpen(false);
	};

	const handleAccessInformationClose = () => {
		setAccessInformationOpen(false);
	};

	const handleAmenityClose = () => {
		setAmenityOpen(false);
	};

	const handleClose = () => {
		toggleOpen(false);
	};

	const handleEventOpen = () => {
		setEvent({
			address: "",
			eventDate: "",
			fromTime: "",
			newsLetterNotificationFiles: [],
			title: "",
			toTime: "",
		});
		setEventOpen(!eventOpen);
	};

	const handleAmenityOpen = () => {
		setAvailableAmenity({ amenityType: "", locations: [] });
		setAmenityOpen(!amenitiyOpen);
	};

	const handleAccessInformationOpen = () => {
		setTempAccessInformation({
			accessFee: "",
			accessForm: [],
			accessFormLink: "",
			accessProcedure: "",
			firstFee: "",
			getAccessInformation: [],
			id: "",
			name: "",
			paymentFormLink: "",
			replacementFee: "",
		});
		setAccessInformationOpen(!accessInformationOpen);
	};

	const handleEditAmenity = (amenity: any) => {
		// setToBeEditedAvailableAmenity(amenity);
		setToBeEditedAvailableAmenity(JSON.parse(JSON.stringify(amenity)));
		setAmenityOpen(!amenitiyOpen);
	};

	const handleEditEvent = (event: any) => {
		setEventOpen(!eventOpen);
		setToBeEditedEvent(event);
	};

	const handleEditAccessInformation = (accessInformation: any) => {
		setAccessInformationOpen(!accessInformationOpen);
		setToBeEditedAccessInformation(accessInformation);
	};

	const handleEventDelete = (event: any) => {
		setToBeDeleteEvent(event);
		toggleOpen(!open);
	};

	const handleAccessInformationDelete = (accessInformation: any) => {
		setToBeDeleteAccessInformation(accessInformation);
		toggleOpen(!open);
	};

	const handleAmenityDelete = (amenity: any) => {
		setToBeDeleteAmenity(amenity);
		toggleOpen(!open);
	};

	return (
		<div style={{ width: "100%", height: props.height, overflowY: "scroll", borderRadius: "4px", fontSize: "20px" }} className="add-municipality-form-container">
			<DeleteAttachmentComp
				hoa={hoa}
				open={open}
				previousHoa={previousHoa}
				setCurrentHoa={setCurrentHoa}
				toggleOpen={toggleOpen}
				handleClose={handleClose}
				documentName={documentName}
				selectedValues={selectedValues}
				selectedDocument={selectedDocument}
				setSelectedDocument={setSelectedDocument}
				toBeDelete={toBeDelete}
				setToBeDelete={setToBeDelete}
				updateHoaData={updateHoaData}
				updateSelectedValues={updateSelectedValues}
				amenities={newAvailableAmenities}
				setAmenities={setNewAvailableAmenities}
				amenitiesDocImage={amenitiesDocImage}
				updateAmenitiesDocImage={updateAmenitiesDocImage}
				toBeDeleteEvent={toBeDeleteEvent}
				setToBeDeleteEvent={setToBeDeleteEvent}
				state={state}
				setState={setState}
				event={event}
				setEvent={setEvent}
				locationIndex={selectedLocationIndex}
				availableAmenity={availableAmenity}
				setAvailableAmenity={setAvailableAmenity}
				setAccessInformation={setAccessInformation}
				setAmenityEvents={setAmenityEvents}
				toBeDeleteAmenity={toBeDeleteAmenity}
				setToBeDeleteAmenity={setToBeDeleteAmenity}
				setToBeDeleteAccessInformation={setToBeDeleteAccessInformation}
				toBeDeleteAccessInformation={toBeDeleteAccessInformation}
				tempAccessInformation={tempAccessInformation}
				setTempAccessInformation={setTempAccessInformation}
				checkNewAmenitiesWarning={checkNewAmenitiesWarning}
				setAmenityOptions={setAmenityOptions}
			/>
			<AddAmenityEvent
				open={eventOpen}
				onClose={handleEventClose}
				view={view}
				state={state}
				setState={setState}
				setAmenities={setAmenityEvents}
				toBeEditedEvent={toBeEditedEvent}
				setToBeEditedEvent={setToBeEditedEvent}
				setDocumentName={setDocumentName}
				document={document}
				setSelectedDocument={setSelectedDocument}
				toggleOpen={toggleOpen}
				deleteOpen={open}
				event={event}
				setEvent={setEvent}
				amenityTags={amenityTags}
				setAmenityTags={setAmenityTags}
				checkNewAmenitiesWarning={checkNewAmenitiesWarning}
			/>
			<AddAmenityModal
				open={amenitiyOpen}
				onClose={handleAmenityClose}
				view={view}
				state={state}
				setState={setState}
				setAmenities={setNewAvailableAmenities}
				toBeEditedAvailableAmenity={toBeEditedAvailableAmenity}
				setToBeEditedAvailableAmenity={setToBeEditedAvailableAmenity}
				setDocumentName={setDocumentName}
				document={document}
				setSelectedDocument={setSelectedDocument}
				toggleOpen={toggleOpen}
				deleteOpen={open}
				setSelectedLocationIndex={setSelectedLocationIndex}
				availableAmenity={availableAmenity}
				setAvailableAmenity={setAvailableAmenity}
				amenityOptions={amenityOptions}
				setAmenityOptions={setAmenityOptions}
				selectedLocationIndex={selectedLocationIndex}
				setToBeDelete={setToBeDelete}
				checkNewAmenitiesWarning={checkNewAmenitiesWarning}
				previousHoa={previousHoa}
			/>
			<AddAccessInformationModal
				open={accessInformationOpen}
				onClose={handleAccessInformationClose}
				view={view}
				state={state}
				setState={setState}
				setAmenities={setAccessInformation}
				toBeEditedAccessInformation={toBeEditedAccessInformation}
				setToBeEditedAccessInformation={setToBeEditedAccessInformation}
				setDocumentName={setDocumentName}
				document={document}
				setSelectedDocument={setSelectedDocument}
				toggleOpen={toggleOpen}
				deleteOpen={open}
				tempAccessInformation={tempAccessInformation}
				setTempAccessInformation={setTempAccessInformation}
				checkNewAmenitiesWarning={checkNewAmenitiesWarning}
			/>
			<div className="left-form-container">
				<div style={{ margin: "24px 0px", paddingBottom: "14px" }}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<div className="sub-title-text">Amenities</div>
						<Button
							style={{ borderColor: "#E8E8E8", color: "#3E3E3E" }}
							onClick={handleAmenityOpen}
							startIcon={<AddIcon color="primary" />}
							variant="outlined"
							disabled={isHoaFieldDisabled("newAvailableAmenities")}
						>
							Add Amenity
						</Button>
					</div>
					{Array.isArray(state?.newAvailableAmenities) && state.newAvailableAmenities.length > 0 ? (
						<>
							{state?.newAvailableAmenities.map((amenity: any, index: number) => {
								for (const key of Object.keys(config.amenityIcons)) {
									if (key === amenity.amenityType) {
										return (
											<Card key={index} variant="outlined" style={{ background: "#FAFAFA", marginTop: "24px" }} className="violation-card-container">
												<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
													<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
														<div style={{ display: "flex", alignItems: "center" }}>
															{React.createElement(config.amenityIcons[key], { color: "primary" })}
															<Typography style={{ marginLeft: "12px", color: "#3E3E3E", fontSize: "14px", fontWeight: "500" }}>
																{key === "Beache Access" ? "Beach Access" : key}
															</Typography>
														</div>
													</div>
													<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
														<IconButton onClick={() => handleEditAmenity(amenity)} disabled={isHoaFieldDisabled("newAvailableAmenities")}>
															<EditOutlinedIcon />
														</IconButton>
														<IconButton onClick={() => handleAmenityDelete(amenity)} disabled={isHoaFieldDisabled("newAvailableAmenities")}>
															<DeleteOutlineIcon />
														</IconButton>
													</div>
												</Stack>
												<Stack direction={"column"} mt={"16px"} sx={{ wordBreak: "break-all" }}>
													{amenity?.locations?.length
														? amenity?.locations?.map((location: any, index: number) => {
																return (
																	<Stack
																		key={index}
																		pb={"2px"}
																		pt={"2px"}
																		direction={"row"}
																		alignItems={"center"}
																		borderBottom={index !== amenity.locations.length - 1 ? "1px solid #E8E8E8" : ""}
																	>
																		<div>
																			<IconButton style={{ fontSize: "14px", color: "#323232", paddingLeft: "0px" }}>
																				<LocationIcon />
																			</IconButton>
																		</div>
																		<span style={{ fontSize: "12px", color: "#787878" }}>{location.address}</span>
																	</Stack>
																);
														  })
														: null}
												</Stack>
											</Card>
										);
									}
								}
							})}
						</>
					) : (
						<AmenityEntityBlankComponent type={"amenities"} title={"No Amenities Found"} subTitle={"Please click on Add Amenity to add amenities to this HOA"} />
					)}
				</div>
			</div>

			{/*RIGHT*/}
			<div className="right-form-container" style={{ wordBreak: "break-all" }}>
				<div style={{ margin: "24px 0px", paddingBottom: "14px" }}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<div className="sub-title-text">Amenity Events</div>
						<Button
							style={{ borderColor: "#E8E8E8", color: "#3E3E3E" }}
							onClick={handleEventOpen}
							startIcon={<AddIcon color="primary" />}
							variant="outlined"
							disabled={isHoaFieldDisabled("amenityEvents")}
						>
							Add Event
						</Button>
					</div>
					{Array.isArray(state?.amenityEvents) && state.amenityEvents.length > 0 ? (
						<>
							{state.amenityEvents.map((event: any, index: number) => (
								<Card key={index} variant="outlined" style={{ background: "#FAFAFA", marginTop: "24px" }} className="violation-card-container">
									<Stack direction={"row"} justifyContent={"space-between"}>
										<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
											{event.eventDate ? (
												<Typography style={{ fontSize: "12px", paddingBottom: "10px", color: "#787878", fontWeight: "500" }}>{`${getDateOnly(
													event?.eventDate
												)} -  ${getDateOnly(event?.endDate)}|  ${event?.fromTime} - ${event?.toTime}`}</Typography>
											) : null}
											<Typography style={{ fontSize: "14px", color: "#3E3E3E", fontWeight: "500" }}>{event.title}</Typography>
										</div>
										<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
											<IconButton onClick={() => handleEditEvent(event)} disabled={isHoaFieldDisabled("amenityEvents")}>
												<EditOutlinedIcon />
											</IconButton>
											<IconButton onClick={() => handleEventDelete(event)} disabled={isHoaFieldDisabled("amenityEvents")}>
												<DeleteOutlineIcon />
											</IconButton>
										</div>
									</Stack>
									<Stack direction={"row"} mt={1} pb={"2px"} pt={"2px"} alignItems={"center"} borderBottom={"1px solid #E8E8E8"}>
										<div>
											<IconButton style={{ fontSize: "14px", color: "#323232" }}>
												<LocationIcon />
											</IconButton>
										</div>
										<span style={{ fontSize: "12px", color: "#787878" }}>{event.address}</span>
									</Stack>
									<Stack direction={"row"} mt={1} mb={1} p={"2px"} alignItems={"center"} borderBottom={"1px solid #E8E8E8"}>
										<span style={{ fontSize: "12px", color: "#787878", paddingBottom: "3px" }}>{event?.additionalInformation}</span>
									</Stack>
									{event.newsLetterNotificationFiles && event.newsLetterNotificationFiles.length > 0 ? (
										<Stack direction={"row"} alignItems={"center"}>
											<div>
												<IconButton>
													<DescriptionIcon />
												</IconButton>
											</div>
											<span style={{ fontSize: "12px" }}>Newsletter & Notification</span>
										</Stack>
									) : null}
								</Card>
							))}
						</>
					) : (
						<AmenityEntityBlankComponent type={"amenityEvents"} title={"No Events Found"} subTitle={"Please click on Add Event to add Event to this HOA"} />
					)}
				</div>

				<div style={{ margin: "24px 0px", paddingBottom: "14px" }}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<div className="sub-title-text">Access Information</div>
						<Button
							style={{ borderColor: "#E8E8E8", color: "#3E3E3E" }}
							onClick={handleAccessInformationOpen}
							startIcon={<AddIcon color="primary" />}
							variant="outlined"
							disabled={isHoaFieldDisabled("accessInformation")}
						>
							Add Access Information
						</Button>
					</div>
					{Array.isArray(state?.accessInformation) && state.accessInformation.length > 0 ? (
						<>
							{state.accessInformation.map((accessInformation: any, index: number) => (
								<Card key={index} variant="outlined" style={{ background: "#FAFAFA", marginTop: "24px" }} className="violation-card-container">
									<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
										<div style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
											<Typography style={{ fontSize: "14px", color: "#3E3E3E", fontWeight: "500" }}>{accessInformation.name}</Typography>
										</div>
										<div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
											<IconButton onClick={() => handleEditAccessInformation(accessInformation)} disabled={isHoaFieldDisabled("accessInformation")}>
												<EditOutlinedIcon />
											</IconButton>
											<IconButton onClick={() => handleAccessInformationDelete(accessInformation)} disabled={isHoaFieldDisabled("accessInformation")}>
												<DeleteOutlineIcon />
											</IconButton>
										</div>
									</Stack>
									<Stack direction={"column"} sx={{ wordBreak: "break-all" }}>
										<div style={{ borderBottom: "1px solid #E8E8E8" }}>
											<Typography style={{ fontSize: "12px", color: "#787878", lineHeight: "16px", paddingBottom: "8px" }}>{accessInformation.accessProcedure}</Typography>
										</div>
										<Stack direction={"row"} mt={2}>
											<Stack direction={"column"} width={"128px"}>
												<Typography style={{ fontSize: "14px", color: "#787878", fontWeight: "500" }}>First Fee</Typography>
												<div>
													<Typography style={{ fontSize: "16px", color: "#303030" }}>{getNegativeValueInAccountingForm(accessInformation.firstFee)}</Typography>
												</div>
											</Stack>
											<Stack direction={"column"} width={"128px"}>
												<Typography style={{ fontSize: "14px", color: "#787878", fontWeight: "500" }}>Access Fee</Typography>
												<div>
													<Typography style={{ fontSize: "16px", color: "#303030" }}>{getNegativeValueInAccountingForm(accessInformation.accessFee)}</Typography>
												</div>
											</Stack>
											<Stack direction={"column"} width={"128px"}>
												<Typography style={{ fontSize: "14px", color: "#787878", fontWeight: "500" }}>Replacement Fee</Typography>
												<div>
													<Typography style={{ fontSize: "16px", color: "#303030" }}>{getNegativeValueInAccountingForm(accessInformation.replacementFee)}</Typography>
												</div>
											</Stack>
										</Stack>
									</Stack>
								</Card>
							))}
						</>
					) : (
						<AmenityEntityBlankComponent type={"accessInformation"} title={"No Information Found"} subTitle={"Please click on Add Access Information to this HOA"} />
					)}
				</div>
			</div>
		</div>
	);
}
